import {
  createRouter,
  createWebHistory,
} from 'vue-router';

import BasePage from '@/pages/BasePage.vue';

const cmsRoutes = window.ioappConfig.routes.map((route) => ({
  name: route.name,
  path: route.path,
  meta: route.meta,
  component: BasePage,
}));

const routes = [
  ...cmsRoutes,
  {
    path: '/:catchAll(.*)',
    component: BasePage,
  },
];

const router = createRouter({
  history: createWebHistory('/'),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    }

    return {
      top: 0,
    };
  },
});

export default router;
